// Audio Description Studio Signal constants, from BBC R&D White Paper WHP 198
// (Trevor Ware, August 2011). Section references are to that paper.

/** Serial data rate in bits per second (§3). */
export const BIT_RATE = 1280;

/** AD_descriptor packets per second; the fade value updates 10x/s (§3). */
export const PACKETS_PER_SECOND = 10;

/** Fixed AD_descriptor length including the 2 CRC bytes (§3, Appendix A). */
export const PACKET_BYTES = 16;

/** Bits per packet (16 bytes, MSB of the first byte first). */
export const PACKET_BITS = PACKET_BYTES * 8;

/**
 * Leading AD_descriptor bytes (Appendix A): reserved nibble 0xF with
 * AD_descriptor_length 0x8, AD_text_tag "DTGAD", Version_text_tag 0x31.
 */
export const DESCRIPTOR_HEADER = [0xf8, 0x44, 0x54, 0x47, 0x41, 0x44, 0x31];

/** Reserved byte value used for the bytes between pan and the CRC. */
export const RESERVED_BYTE = 0xff;

/**
 * Peak 16-bit sample value: logic 1 = 0x0200, logic 0 = 0xFE00 (-512),
 * a fixed -36 dBFS level (§5).
 */
export const LEVEL_16BIT = 0x0200;

/** Approximate attenuation per AD_fade_byte step (ETSI TS 101 154). */
export const FADE_DB_PER_STEP = 0.3;

/** Sample rate used for exported control tracks (typical AES3 rate, §5). */
export const DEFAULT_SAMPLE_RATE = 48000;

/** Width in samples of the raised-cosine edge shaping each transition (§5). */
export const EDGE_WIDTH_SAMPLES = 6;
